export type ImportProgressLabelParams = {
  batch: { current: number; currentFileName: string; total: number } | null;
  fileNames: string[];
  hasPendingImports: boolean;
};

export const getImportProgressLabel = ({ batch, fileNames, hasPendingImports }: ImportProgressLabelParams): string => {
  if (batch != null && batch.total >= 1) {
    const position = `${batch.current} of ${batch.total}`;

    if (batch.currentFileName) {
      return `Importing ${position} — ${batch.currentFileName}`;
    }

    return `Preparing import ${position}…`;
  }

  if (fileNames.length === 1) {
    return `Importing ${fileNames[0]}`;
  }

  if (fileNames.length > 1) {
    return `Importing ${fileNames.length} files`;
  }

  if (hasPendingImports) {
    return 'Preparing import…';
  }

  return 'Importing…';
};
